import { PublicClientApplication, type Configuration } from '@azure/msal-browser';

import { env } from './config';

export { env };

const msalConfig: Configuration = {
  auth: {
    clientId: env.clientId,
    // Single-tenant authority: only endpointas.com accounts can sign in.
    authority: `https://login.microsoftonline.com/${env.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = { scopes: [env.apiScope] };
